module.exports = __webpack_public_path__ + "assets/img/user4.415c0516.jpg";